export default __webpack_public_path__ + "994e34451cc19ede31d30802a480542b.woff";